import { render, staticRenderFns } from "./CreateLinkModal.vue?vue&type=template&id=644a5a6d&scoped=true"
import script from "./CreateLinkModal.vue?vue&type=script&lang=js"
export * from "./CreateLinkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a5a6d",
  null
  
)

export default component.exports